import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  Head,
  HeadingStyled,
  ButtonStyled,
  Body,
} from './Accordion.styled';

export const accordionSize = {
  SMALL: 'small',
  DEFAULT: 'default',
};

export const accordionVariant = {
  DEFAULT: 'default',
  MENU: 'menu',
};

class UIStore {
  @observable isUnfolded = false;
  @action SetIsUnfolded = bool => {
    this.isUnfolded = bool;
  };
}

@observer
class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.uiStore = new UIStore();
  }

  render() {
    const { className, title, children, unfolded, size, variant } = this.props;
    const { isUnfolded, SetIsUnfolded } = this.uiStore;
    return (
      <Wrapper className={className} variant={variant}>
        <Head
          variant={variant}
          onClick={() => SetIsUnfolded(!isUnfolded)}
          size={size}
        >
          <HeadingStyled size={size} level={2}>
            {title}
          </HeadingStyled>
          {!unfolded && (
            <ButtonStyled
              variant='secondary'
              icon={isUnfolded ? 'caret_up' : 'caret_down'}
              parentSize={size}
              size='xsmall'
              outline
            />
          )}
        </Head>
        <Body size={size} isVisible={isUnfolded || unfolded}>
          {children}
        </Body>
      </Wrapper>
    );
  }
}

export default Accordion;

Accordion.defaultProps = {
  unfolded: false,
  variant: accordionVariant.DEFAULT,
  size: accordionSize.DEFAULT,
};

Accordion.propTypes = {
  className: PropTypes.string,
  /**
   * Main text for the Accordion
   */
  title: PropTypes.string.isRequired,
  /**
   * Content to show when the Accordion is unfolded
   */
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /**
   * Manage folded and unfolded behavior
   */
  unfolded: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(accordionSize)),
  /**
   * Defines different appearances for the component
   */
  variant: PropTypes.oneOf(Object.values(accordionVariant)),
};
